export const skillsList = [
  "HTML",
  "CSS",
  "JavaScript",
  "React",
  "Node",
  "Express",
  "MongoDB",
  "MySQL",
  "Python",
  "Django",
  "Flask",
  "AWS",
  "Firebase",
  "Git",
  "Linux",
  "C",
  "C++",
  "C#",
  "Java",
  "PHP",
  "Ruby",
  "Swift",
  "Kotlin",
];

export const domainList = [
  "Web Development",
  "Mobile Development",
  "Desktop Development",
  "Machine Learning",
  "Data Science",
  "Artificial Intelligence",
  "Cloud Computing",
  "Cyber Security",
  "Game Development",
  "Embedded Systems",
  "Internet of Things",
  "Blockchain",
  "UI/UX Design",
  "Digital Marketing",
  "Content Writing",
  "Graphic Design",
  "Video Editing",
  "Animation",
  "3D Modelling",
  "3D Animation",
  "3D Rendering",
  "3D Printing",
];
